/**
 * Item types for graded item types.
 */
const GradedItemTypes = {
  Quiz: 'exam',
  Programming: 'gradedProgramming',
  StaffGraded: 'staffGraded',
  TeammateReview: 'teammateReview',
  GradedDiscussionPrompt: 'gradedDiscussionPrompt',
  Peer: 'phasedPeer',
  GradedLTI: 'gradedLti',
  WiseFlow: 'wiseFlow',
};

export default GradedItemTypes;

export const { Quiz, Programming, StaffGraded, TeammateReview, GradedDiscussionPrompt, Peer, GradedLTI, WiseFlow } =
  GradedItemTypes;
